import React from 'react';
import {AccountSettingsPanel} from '@common/auth/ui/account-settings/account-settings-panel';
import {Trans} from '@ui/i18n/trans';
import {User} from '@ui/types/user';
import {useApplyUserTheme, useUserThemes} from '@ui/themes/user-themes';
import {UserThemeSelector} from '@ui/themes/user-theme-selector';

interface Props {
  user: User;
}

export function ThemePanel({user}: Props) {
  const userThemes = useUserThemes({enabled: !!user});
  const applyTheme = useApplyUserTheme();

  return (
    <AccountSettingsPanel id="theme" title={<Trans message="Aparência / Tema" />}>
      <div className="max-w-960 space-y-20">
        <p className="text-muted">
          <Trans message="Escolha seu tema entre as opções disponíveis para o seu plano." />
        </p>
        <UserThemeSelector
          themes={userThemes.themes}
          selectedThemeId={userThemes.selectedThemeId}
          isLoading={userThemes.isLoading}
          isApplying={applyTheme.isPending}
          onSelect={themeId => applyTheme.mutate(themeId)}
        />
      </div>
    </AccountSettingsPanel>
  );
}
